import { Component, forwardRef, Inject, Input } from '@angular/core'
import { AlgoliaInstantsearchComponent } from '@app-domains/algolia/components/algolia-instantsearch.component'
import { FilterItem } from './refinement-list-base/refinement-list-base.component'

@Component({
    selector: 'app-refinement-list',
    template: `
        <app-refinement-list-base [attribute]="attribute"
                                  [localisedAttribute]="localisedAttribute"
                                  [operator]="operator"
                                  [instantSearchInstance]="instantSearchInstance"
                                  [customLabels]="customLabels"
        ></app-refinement-list-base>
    `,
})
export class RefinementListComponent {

    @Input()
    public attribute: string

    @Input()
    public localisedAttribute: string

    @Input()
    public operator: 'and' | 'or'

    @Input()
    public customLabels?: FilterItem[]

    constructor(
        @Inject(forwardRef(() => AlgoliaInstantsearchComponent))
        public instantSearchInstance: AlgoliaInstantsearchComponent,
    ) {
    }
}
